/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsuredSummaryDto
 */
export interface InsuredSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof InsuredSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredSummaryDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredSummaryDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredSummaryDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredSummaryDto
     */
    source?: string;
    /**
     * 
     * @type {number}
     * @memberof InsuredSummaryDto
     */
    numberOfContracts?: number;
    /**
     * 
     * @type {number}
     * @memberof InsuredSummaryDto
     */
    annualPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof InsuredSummaryDto
     */
    iconKey?: string;
}

/**
 * Check if a given object implements the InsuredSummaryDto interface.
 */
export function instanceOfInsuredSummaryDto(value: object): value is InsuredSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function InsuredSummaryDtoFromJSON(json: any): InsuredSummaryDto {
    return InsuredSummaryDtoFromJSONTyped(json, false);
}

export function InsuredSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuredSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'],
        'email': json['email'],
        'phone': json['phone'],
        'source': json['source'] == null ? undefined : json['source'],
        'numberOfContracts': json['numberOfContracts'] == null ? undefined : json['numberOfContracts'],
        'annualPrice': json['annualPrice'] == null ? undefined : json['annualPrice'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
    };
}

export function InsuredSummaryDtoToJSON(json: any): InsuredSummaryDto {
    return InsuredSummaryDtoToJSONTyped(json, false);
}

export function InsuredSummaryDtoToJSONTyped(value?: InsuredSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'email': value['email'],
        'phone': value['phone'],
        'source': value['source'],
        'numberOfContracts': value['numberOfContracts'],
        'annualPrice': value['annualPrice'],
        'iconKey': value['iconKey'],
    };
}

